import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    verifyCashOut, notVerifyCashOut, getCashFlowOrders, getCashFlow, cancelOrder, clearCashFlow, getCashFlowOrderDetail,
    cashFlowRegisterCountGet, cashFlowRegisterCountClear
} from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { formError, formInput } from 'actions/FormActions';
import { getCsvReport } from 'actions/ReportsAction';
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import util from 'library/util';
import Grid from 'screens/components/basic/Grid';
import { cashRegisterViewCrumb } from 'utils/breadcrumbInfo';
import { MeasurementType, OrderDiscountType, OrderProductStatus, OrderStatus } from 'constants/enums';
import DialogHeader from 'screens/components/basic/DialogHeader'
import CashCountDialog from './CashCountDialog';
import moment from 'moment';
import GenericTable from 'screens/components/advanced/GenericTable';
import { mapCashflowNote } from 'utils/mappers';
import WithRouter from 'custom/withRouter';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

class CashRegisterSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            status: null,
            dialogCancelOrder: false,
            selectedOrder: 0,
            orderNotes: null,
            sortedCashFlowOrders: [...props.cashFlowOrders]
        };
        this.ws = null;
        this.verifyFlag = false;
        this.notVerifyFlag = false;
    }

    // control if is ADD or EDIT
    componentWillMount() {
        this.props.formInput('', this.props.name + "CashOutAmount");
        this.props.formInput(null, this.props.name + "SaveSuccess");
        this.props.formInput(null, this.props.name + "SaveError");
        this.props.formInput('', this.props.name + "Notes");
        this.props.formInput('', `${this.props.name}CancellationNotes`);

        const cashFlowId = this.props.params ? this.props.params.id : 0;
        //if true dispatch an action to retrive data from API and set Status to EDIT
        if (cashFlowId) {
            this.setState({ status: "EDIT" });
            this.props.getCashFlow(cashFlowId, this.props.branchId);
            this.props.getCashFlowOrders(cashFlowId, this.props.branchId);
            this.props.cashFlowRegisterCountGet(cashFlowId);
        }
        //if false dispatch an action to clean the form and set default values and set Status to ADD
        else {
            this.setState({ status: "ADD" });
        }

        try {
            this.initWebSocket();
        } catch (err) {
            console.log(`WebSocket Error: ${err}`);
            this.initWebSocket();
        }
    }

    // is SUCCEEDED or FAILED
    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess) || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }
        // order cancelled
        if (this.props.posOrderCancelled !== newProps.posOrderCancelled && newProps.posOrderCancelled !== undefined && newProps.posOrderCancelled !== null) {
            if (newProps.posOrderCancelled === true) {
                this.closeDialogCancelOrder();
                const cashFlowId = this.props.params.id;
                this.props.getCashFlowOrders(cashFlowId, this.props.branchId);
                this.cleanCancel();
                window.location.reload();
            }
        }

        if (!this.props.cashFlow && newProps.cashFlow) {
            this.props.formInput(newProps.cashFlow.cashOutAmount.toFixed(2).toString(), this.props.name + "CashOutAmount");
            this.props.formInput(newProps.cashFlow.notes, this.props.name + "Notes");
        }

        if (newProps.printAllReceiptTime !== undefined && newProps.printAllReceiptTime !== null && this.props.printAllReceiptTime != newProps.printAllReceiptTime && newProps.cashFlowOrdersDetail != undefined && newProps.cashFlowOrdersDetail != null) {
            this.printAllReceipt(newProps.cashFlowOrdersDetail);
        }

        this.setState({
            sortedCashFlowOrders: [...newProps.cashFlowOrders]  // Create a copy of the array
                .sort((a, b) => b.orderId - a.orderId)  // Sort by orderId descending
        });

    }

    componentWillUnmount = () => {
        this.props.clearCashFlow();
        if (this.ws) {
            this.ws.close();
        }
        this.props.cashFlowRegisterCountClear();
    }

    initWebSocket = () => {
        try {
            this.ws = new WebSocket("ws://127.0.0.1:5000/");
            this.ws.binaryType = "arraybuffer";

            this.ws.onopen = function () {
                if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                }
            };

            this.ws.onerror = () => {
            };

            this.ws.onclose = (event) => {

                if (event.code !== 99999) {
                    console.log("Websocket is Locked!");
                }
            };

            this.ws.onmessage = (event) => {
                let response = event.data;
                let content = response.split(',');
                let responseType = content[0];
                let value = content[1];

                if (responseType === "LABELPRINTER") {
                    if (value === 'OFFLINE') {
                        this.props.showError("The label printer is offline. Please, Contact the support team.");
                    }
                }

            };

            window.onbeforeunload = function () {
                if (this.ws) {
                    const model = {
                        Command: "CLOSE",
                        Data: null
                    };

                    this.ws.send(JSON.stringify(model));
                    this.ws.close(1000);
                    window.productWebSocket = null;
                }
            };

            window.productWebSocket = this.ws;
        }
        catch (err) {
            console.error(`ERROR ON INIT FUNCTION CATCH: ${err}`);
        }
    }

    printCashout = () => {
        const store = this.props.store;
        const cashFlow = this.props.cashFlow;
        const cashToReceive = (cashFlow.expectedBalance) ? cashFlow.expectedBalance.toFixed(2) : '0.00';
        const cashSale = (cashFlow.cashSale) ? cashFlow.cashSale.toFixed(2) : '0.00';
        const debitSale = (cashFlow.debitTotal) ? cashFlow.debitTotal.toFixed(2) : '0.00';
        const creditSale = (cashFlow.creditTotal) ? cashFlow.creditTotal.toFixed(2) : '0.00';
        const giftcardSale = (cashFlow.giftCardTotal) ? cashFlow.giftCardTotal.toFixed(2) : '0.00';
        const totalSale = (cashFlow.balance) ? cashFlow.balance.toFixed(2) : '0.00';
        const tips = (cashFlow.tipsTotal) ? cashFlow.tipsTotal.toFixed(2) : '0.00';
        const cashIn = (cashFlow.cashInAmount) ? cashFlow.cashInAmount.toFixed(2) : '0.00';
        const cashRefund = (cashFlow.cashRefund) ? cashFlow.cashRefund.toFixed(2) : '0.00';
        const creditReturn = (cashFlow.creditReturn) ? cashFlow.creditReturn.toFixed(2) : '0.00';
        const debitReturn = (cashFlow.debitReturn) ? cashFlow.debitReturn.toFixed(2) : '0.00';
        const storeCreditReturn = (cashFlow.storeCreditReturn) ? cashFlow.storeCreditReturn.toFixed(2) : '0.00';
        const giftCardReturn = (cashFlow.giftCardReturn) ? cashFlow.giftCardReturn.toFixed(2) : '0.00';
        const cashTransactionCount = (cashFlow.cashTransactionCount) ? cashFlow.cashTransactionCount : 0;
        const debitTransactionCount = (cashFlow.debitTransactionCount) ? cashFlow.debitTransactionCount : 0;
        const creditTransactionCount = (cashFlow.creditTransactionCount) ? cashFlow.creditTransactionCount : 0;
        const giftTransactionCount = (cashFlow.giftTransactionCount) ? cashFlow.giftTransactionCount : 0;
        const cashOutDate = cashFlow.cashOutDate;
        const cashDrops = cashFlow.cashDrops.map(c => {
            return {
                Amount: c.amount,
                TimeText: c.cashDropTimeText
            };
        });

        let cashOutCounts = this.props.cashRegisterCount && this.props.cashRegisterCount.filter(item => item.type == 3) ? this.props.cashRegisterCount.filter(item => item.type == 3)[0] : [];

        const hundredCount = cashOutCounts ? cashOutCounts.hundredCount ? cashOutCounts.hundredCount : 0 : 0;
        const fiftyCount = cashOutCounts ? cashOutCounts.fiftyCount ? cashOutCounts.fiftyCount : 0 : 0;
        const twentyCount = cashOutCounts ? cashOutCounts.twentyCount ? cashOutCounts.twentyCount : 0 : 0;
        const tenCount = cashOutCounts ? cashOutCounts.tenCount ? cashOutCounts.tenCount : 0 : 0;
        const fiveCount = cashOutCounts ? cashOutCounts.fiveCount ? cashOutCounts.fiveCount : 0 : 0;
        const twoCount = cashOutCounts ? cashOutCounts.twoCount ? cashOutCounts.twoCount : 0 : 0;
        const oneCount = cashOutCounts ? cashOutCounts.oneCount ? cashOutCounts.oneCount : 0 : 0;
        const twentyFiveCoinCount = cashOutCounts ? cashOutCounts.twentyFiveCoinCount ? cashOutCounts.twentyFiveCoinCount : 0 : 0;
        const tenCoinCount = cashOutCounts ? cashOutCounts.tenCoinCount ? cashOutCounts.tenCoinCount : 0 : 0;
        const fiveCoinCount = cashOutCounts ? cashOutCounts.fiveCoinCount ? cashOutCounts.fiveCoinCount : 0 : 0;

        const actualCashoutAmount = this.props.amount;
        if (this.ws && this.ws.readyState === WebSocket.OPEN && !this.props.padVersion) {
            const model = {
                Command: 'PRINT CASHOUT',
                Data: JSON.stringify({
                    CompanyName: store.name,
                    EmployeeName: this.props.receiptShowEmployee ? `${cashFlow.employee.firstName} ${cashFlow.employee.lastName}` : "",
                    Register: JSON.parse(localStorage.getItem(this.props.deviceKeyName)).deviceWorkStationName,
                    CashToReceive: cashToReceive,
                    CashSale: cashSale,
                    DebitSale: debitSale,
                    CreditSale: creditSale,
                    TotalSale: totalSale,
                    GiftSale: giftcardSale,
                    Tips: tips,
                    CashIn: cashIn,
                    CashRefund: cashRefund,
                    CreditReturn: creditReturn,
                    DebitReturn: debitReturn,
                    GiftCardReturn: giftCardReturn,
                    StoreCreditReturn: storeCreditReturn,
                    CashTransactionCount: cashTransactionCount,
                    DebitTransactionCount: debitTransactionCount,
                    CreditTransactionCount: creditTransactionCount,
                    GiftTransactionCount: giftTransactionCount,
                    CashoutDate: cashOutDate,
                    CashDrops: cashDrops,
                    HundredBill: hundredCount,
                    FiftyBill: fiftyCount,
                    TwentyBill: twentyCount,
                    TenBill: tenCount,
                    FiveBill: fiveCount,
                    TwoCoin: twoCount,
                    OneCoin: oneCount,
                    TwentyFiveCoin: twentyFiveCoinCount,
                    TenCoin: tenCoinCount,
                    FiveCoin: fiveCoinCount,
                    ActualCashoutAmount: actualCashoutAmount
                })
            };
            this.ws.send(JSON.stringify(model));
        }
        else if (this.props.padVersion) {
            const model = {
                Command: 'PRINT CASHOUT',
                Data: {
                    CompanyName: store.name,
                    Location: "",
                    EmployeeId: 0,
                    EmployeeName: `${cashFlow.employee.firstName} ${cashFlow.employee.lastName}`,
                    Register: "",
                    CashToReceive: cashToReceive,
                    CashSale: cashSale,
                    DebitSale: debitSale,
                    CreditSale: creditSale,
                    TotalSale: totalSale,
                    GiftSale: giftcardSale,
                    Tips: tips,
                    CashIn: cashIn,
                    CashRefund: cashRefund,
                    CreditReturn: creditReturn,
                    DebitReturn: debitReturn,
                    GiftCardReturn: giftCardReturn,
                    StoreCreditReturn: storeCreditReturn,
                    CashTransactionCount: cashTransactionCount,
                    DebitTransactionCount: debitTransactionCount,
                    CreditTransactionCount: creditTransactionCount,
                    GiftTransactionCount: giftTransactionCount,
                    CashDrops: cashDrops,
                    HundredBill: hundredCount,
                    FiftyBill: fiftyCount,
                    TwentyBill: twentyCount,
                    TenBill: tenCount,
                    FiveBill: fiveCount,
                    TwoCoin: twoCount,
                    OneCoin: oneCount,
                    TwentyFiveCoin: twentyFiveCoinCount,
                    TenCoin: tenCoinCount,
                    FiveCoin: fiveCoinCount,
                    ActualCashoutAmount: actualCashoutAmount
                }
            };
            cashoutPrinting(JSON.stringify(model));
        }
    }
    // A state mutate is happening when print all button is clicked
    printAllReceipt = (cashFlowOrdersDetail) => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN || this.props.padVersion) {
            for (let i = 0; i < cashFlowOrdersDetail.length; i++) {

                setTimeout(() => {
                    const store = this.props.store;
                    const order = cashFlowOrdersDetail[i];
                    const patientId = order.patientId;

                    let memberSavings = 0;
                    order.products.map(x => memberSavings += (x.status == 1 || x.status == 2) ? (x.originalNonMemberPrice - x.price) : 0);

                    let productCount = 0;
                    order.products.map(x => productCount += x.quantity);

                    let data = {
                        NumberOfCopies: 1,
                        CompanyName: this.props.isShopNameDisplayed ? store.name : "",
                        CompanyWebSite: store.site,
                        CompanyAddress: store.street,
                        CompanyCity: store.city,
                        CompanyStateProvince: store.provinceState,
                        CompanyCountry: store.country,
                        CompanyPostalCode: store.postalCode,
                        CompanyPhone: store.phone,
                        GSTNumber: this.props.receiptShowGSTNumber ? store.GSTNumber : "",
                        PatientId: patientId,
                        OrderId: this.props.receiptShowOrderNumber ? order.id : "",
                        OnlineOrderCode: order ? (order.onlineOrderCode !== null || order.onlineOrderCode !== undefined) ? order.onlineOrderCode : null : null,
                        Register: this.props.receiptShowTerminal ? order.deviceName : "",
                        RewardPoint: order.patientRewardPoints ? order.patientRewardPoints.toFixed(0) : 0,
                        IsCompleted: false,
                        Paid: order.paid,
                        ShippingCost: order.shippingCost,
                        SubTotal: order.subTotal.toFixed(2),
                        DepositAmount: order.depositAmount.toFixed(2),
                        SubTotalWithDiscount: order.subTotal !== order.subTotalIncludingDiscounts ? order.subTotalIncludingDiscounts.toFixed(2) : order.subTotal.toFixed(2),
                        Total: order.total.toFixed(2),
                        Tips: order.tipAmount ? order.tipAmount.toFixed(2) : "0.00",
                        Due: order.balanceDue.toFixed(2),
                        Change: order.change.toFixed(2),
                        Refund: (order.refund) ? order.refund.toFixed(2) : 0,
                        EmployeeFirstName: this.props.receiptShowEmployee ? (this.props.showEmployeeNameOnReceipt ? order.employeeFirstName : order.employeeId) : "",
                        PosReceiptBottomText: this.props.posReceiptBottomText,
                        CreatedDate: this.props.receiptShowCreatedDate ? order.createdDate : null,
                        CompletedDate: order.completedDate,
                        RefundDate: order.refundDate,
                        Products: order.products.map(p => {
                            return {
                                ProductId: p.id,
                                SKU: p.sku,
                                ProductName: p.name,
                                Quantity: p.measurementType === MeasurementType.Unit
                                    ? p.quantity.toFixed(0)
                                    : p.measurementType === MeasurementType.Gram
                                        ? p.quantity.toFixed(2)
                                        : (p.quantity / p.weightPerUnit).toFixed(0),
                                Price: p.status === OrderProductStatus.ReturnedStoreCredit || p.status === OrderProductStatus.ReturnedCreditCard || p.status === OrderProductStatus.ReturnedDebitCard || p.status === OrderProductStatus.ReturnedCash || p.status === OrderProductStatus.ReturnedGiftCard
                                    ? (p.discountType !== null ? p.newPrice.toFixed(2) : p.price.toFixed(2))
                                    : p.price.toFixed(2),
                                IsVoided: p.status === OrderProductStatus.Voided,
                                OrderProductDiscountReason: p.orderProductDiscountReason,
                                DiscountText: p.discountType !== null ?
                                    p.discountType === OrderDiscountType.Percentage ? `Discount of ${p.discountAmount.toFixed(0)} %` : `Discount of $ ${p.discountAmount.toFixed(2)}`
                                    : '',
                                PriceWithDiscount: p.discountType !== null ? p.newPrice.toFixed(2) : '0.00',
                                IsUnitProduct: p.isUnitProduct,
                                PricePerUnit: p.pricePerUnit || 0,
                                LotNumber: p.packageReference,
                                WeightPerUnit: p.weightPerUnit || 0,
                                IsRefunded: p.status === OrderProductStatus.ReturnedStoreCredit || p.status === OrderProductStatus.ReturnedCreditCard || p.status === OrderProductStatus.ReturnedDebitCard || p.status === OrderProductStatus.ReturnedCash || p.status === OrderProductStatus.ReturnedGiftCard,
                                OriginalNonMemberPrice: p.originalNonMemberPrice.toFixed(2)
                            };
                        }),
                        Discounts: order.discounts.map((item) => {
                            return {
                                text: item.text,
                                value: item.amount.toFixed(2)
                            };
                        }),
                        TaxRates: order.taxesRate.map(t => {
                            return {
                                name: t.name,
                                value: t.value.toFixed(2)
                            };
                        }),
                        MemberSavings: this.props.receiptShowMemberSavings ? memberSavings : 0,
                        ProductCount: this.props.receiptShowProductCount ? productCount : 0,
                        UseFNTax: order.useFNTax,
                        TaxExemptAll: order.taxExemptAll
                    };

                    order.payments.map(p => {
                        data[p.name] = p.value.toFixed(2);
                        return;
                    });
                    order.taxesRate.map(t => {
                        data[t.name] = t.value.toFixed(2);
                        return;
                    });

                    if (data.Discounts.length === 0 && data.SubTotal !== data.SubTotalWithDiscount) {
                        data.Discounts.push({
                            text: 'Discount on Products',
                            value: (data.SubTotal - data.SubTotalWithDiscount).toFixed(2)
                        });
                    }

                    data.memberLabel = store.memberLabelReceipt;
                    data.hideMedicalMessage = store.hideMedicalLabelReceipt;
                    data.HideRewards = store.hideRewardsReceipt;
                    data.fianlSaleTextShowOnReceipt = this.props.fianlSaleTextShowOnReceipt;
                    data.fulfillmentEnabled = this.props.fulfillmentEnabled;
                    data.showOriginalNonMemberPrice = this.props.showOriginalNonMemberPrice;
                    data.inStoreTipEnabled = this.props.inStoreTipEnabled;

                    if (this.ws && this.ws.readyState === WebSocket.OPEN && !this.props.padVersion) {
                        const model = {
                            Command: "PRINT INVOICE",
                            Data: JSON.stringify(data)
                        };
                        this.ws.send(JSON.stringify(model));
                    }
                    else if (this.props.padVersion) {
                        const model = {
                            Command: "PRINT INVOICE",
                            Data: data
                        };
                        printing(JSON.stringify(model));
                    }
                }, 500 * i);
            }
        }
    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    //when data is saved successfully
    saveSuccess = () => {
        this.redirectToListCashFlow();
        this.props.showSnackbar(
            this.verifyFlag ? LOOKUP.cashregister.messages.verifiedMessage : LOOKUP.cashregister.messages.notVerifiedMessage);
    }

    //when data is not saved, failure
    saveFailure = () => {
        this.props.showError(LOOKUP.cashregister.messages.saveErrorMessage);
    }

    redirectToListCashFlow = () => {
        this.props.navigate("/admin/cashregister");
    }

    openDialogCancelOrder = (orderId, notes) => {
        this.setState({ dialogCancelOrder: true, selectedOrder: orderId, orderNotes: notes });
    }

    closeDialogCancelOrder = () => {
        this.setState({ dialogCancelOrder: false, selectedOrder: 0 });
    }

    cleanCancel = () => {
        this.props.formInput('', `${this.props.name}CancellationNotes`);
        this.props.formInput(null, `posOrderCancelled`);
    }

    cancelOrder = () => {
        const model = {
            orderId: this.state.selectedOrder,
            Notes: this.props.cancellationNotes,
            branchId: this.props.branchId,
            employeeId: this.props.userPin.employee.id,
            cashFlowId: this.props.cashFlow.id
        };

        this.props.cancelOrder(this.state.selectedOrder, model);
    }

    verify = () => {
        const model = this.validateAndGetModel();
        if (model !== null) {
            this.verifyFlag = true;
            this.notVerifyFlag = false;
            this.props.verify(model);
        }
    }

    notVerify = () => {
        const model = this.validateAndGetModel();
        if (model !== null) {
            this.verifyFlag = false;
            this.notVerifyFlag = true;
            this.props.notVerify(model);
        }
    }

    validateAndGetModel = () => {
        const p = this.props;
        const model = {
            id: p.cashFlow.id,
            amount: p.amount,
            notes: p.notes,
            branchId: p.branchId
        };

        const validators = [
            [p.name + 'CashOutAmount', model => model.amount > 0, "Actual Cash Out Amount"]
        ];

        if (util.validate(validators, model, this.props.formError)) {
            return model;
        }

        return null;
    }

    printAll = () => {
        let model = {
            branchId: this.props.branchId,
            cashFlowId: this.props.cashFlow.id
        };
        this.props.getCashFlowOrderDetail(model);
    }

    joinCashInCashDrop = (cashflow) => {
        const cashInsCashDrops = []
        if (cashflow && cashflow.cashIns && cashflow.cashIns.length > 0) {
            cashflow.cashIns.map(item => {
                cashInsCashDrops.push({
                    id: item.id,
                    employee: item.employee,
                    amount: item.amount,
                    date: new Date(item.cashInDate),
                    dateText: item.cashInDateText,
                    timeText: item.cashInTimeText,
                    type: "Cash In"
                })
            });
        } else {
            cashInsCashDrops.push({
                id: cashflow.employee.id,
                employee: cashflow.employee,
                amount: cashflow.cashInAmount,
                date: new Date(cashflow.cashInDate),
                dateText: moment(cashflow.cashInDate).format("MM-DD-YYYY"),
                timeText: moment(cashflow.cashInDate).format("hh:mm A"),
                type: "Cash In"
            })
        }

        if (cashflow && cashflow.cashDrops && cashflow.cashDrops.length > 0) {
            cashflow.cashDrops.map(item => {
                cashInsCashDrops.push({
                    id: item.id,
                    employee: item.employee,
                    amount: item.amount,
                    date: new Date(item.cashDropDate),
                    dateText: item.cashDropDateText,
                    timeText: item.cashDropTimeText,
                    type: item.isPayout ? "Cash Drop (Payout)" : "Cash Drop"
                })
            })
        }

        if (cashflow && cashflow.openDrawers && cashflow.openDrawers.length > 0){
            cashflow.openDrawers.map(item => {
                cashInsCashDrops.push({
                    id: item.id,
                    employee: item.employee,
                    amount: 0,
                    date: new Date(item.openDrawerDate),
                    dateText: item.openDrawerDateText,
                    timeText: item.openDrawerTimeText,
                    type: "Open Drawer"
                })
            });
        }

        cashInsCashDrops.sort((a, b) => a.date.getTime() - b.date.getTime());
        return cashInsCashDrops

    }

    download = () => {
        this.props.getCsvReport(`cashflows/csv?id=${this.props.cashFlow.id}&branchId=${this.props.branchId}`, "cashRegister");
    }

    render() {
        const p = this.props;
        const s = this.state;
        const cashFlow = this.props.cashFlow;

        if (!cashFlow) {
            return null;
        }

        const cashRegisterCount = this.props.cashRegisterCount;
        let cashInsCashDrops = cashFlow ? this.joinCashInCashDrop(cashFlow) : [];
        let totalCashDrop = cashFlow ? cashFlow.cashDrops.filter(item => !item.isPayout).reduce((a, b) => a + b.amount, 0) : 0;
        let totalPayout = cashFlow ? cashFlow.cashDrops.filter(item => item.isPayout).reduce((a, b) => a + b.amount, 0) : 0;
        let pinPasswordEnabled = this.props.applicationSettings.enablePinPasswordOnPOS;

        return (
            <Grid headerContent={cashRegisterViewCrumb}>
                <PageHeaderWithButton title="Cash Register View">
                    <Button
                        type="DownloadButton"
                        className="pull-right btnNewBrandPOS"
                        name="download"
                        label="Download CSV"
                        onTouchTap={this.download}
                    />
                </PageHeaderWithButton>
                <CardSimple className="p-1">
                    <div className="row">
                        <div className="col-lg-6">
                            <table className="table purpleText test">
                                <thead>
                                    <tr>
                                        <th colSpan="2" className="whiteFontColor">{cashFlow.deviceName}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-left">Total Sales(Including Cash, Card and Store Credit)</td>
                                        <td className="text-right">$ {cashFlow.balance.toFixed(2)}</td>
                                    </tr>
                                    {
                                        cashFlow.debitTotal > 0 ? (
                                            <tr className="cashFlowItem">
                                                <td className="text-left">&nbsp;&nbsp;&nbsp;&nbsp;Sales on Debit</td>
                                                <td className="text-right"> $ {cashFlow.debitTotal.toFixed(2)}</td>
                                            </tr>
                                        ) : null
                                    }
                                    {
                                        cashFlow.creditTotal > 0 ? (
                                            <tr className="cashFlowItem">
                                                <td className="text-left">&nbsp;&nbsp;&nbsp;&nbsp;Sales on Credit</td>
                                                <td className="text-right"> $ {cashFlow.creditTotal.toFixed(2)}</td>
                                            </tr>
                                        ) : null
                                    }
                                    {
                                        cashFlow.giftCardTotal > 0 ? (
                                            <tr className="cashFlowItem">
                                                <td className="text-left">&nbsp;&nbsp;&nbsp;&nbsp;Sales on GiftCard</td>
                                                <td className="text-right"> $ {cashFlow.giftCardTotal.toFixed(2)}</td>
                                            </tr>
                                        ) : null
                                    }
                                    <tr className="cashFlowItem">
                                        <td className="text-left">&nbsp;&nbsp;&nbsp;&nbsp;Sales on Cash</td>
                                        <td className="text-right">$ {(cashFlow.cashSale).toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">Cash Drop</td>
                                        <td className="text-right">- $ {totalCashDrop.toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">Cash Drop (Payout)</td>
                                        <td className="text-right">- $ {totalPayout.toFixed(2)}</td>
                                    </tr>
                                    {
                                        cashFlow.cashInAmount && cashFlow.cashInAmount > 0 ?
                                            <tr>
                                                <td className="text-left">Cash In</td>
                                                <td className="text-right">$ {cashFlow.cashInAmount.toFixed(2)}</td>
                                            </tr>
                                            : ""
                                    }
                                    {
                                        cashFlow.cashRefund > 0 ? (
                                            <tr>
                                                <td className="text-left">Cash Refund</td>
                                                <td className="text-right" style={{ color: "red" }}>- $ {cashFlow.cashRefund.toFixed(2)}</td>
                                            </tr>
                                        ) : null
                                    }
                                    {
                                        cashFlow.creditReturn > 0 ? (
                                            <tr>
                                                <td className="text-left">Credit Card Refund</td>
                                                <td className="text-right" style={{ color: "red" }}>- $ {cashFlow.creditReturn.toFixed(2)}</td>
                                            </tr>
                                        ) : null
                                    }
                                    {
                                        cashFlow.debitReturn > 0 ? (
                                            <tr>
                                                <td className="text-left">Debit Card Refund</td>
                                                <td className="text-right" style={{ color: "red" }}>- $ {cashFlow.debitReturn.toFixed(2)}</td>
                                            </tr>
                                        ) : null
                                    }
                                    {
                                        cashFlow.giftCardReturn > 0 ? (
                                            <tr>
                                                <td className="text-left">Gift Card Refund</td>
                                                <td className="text-right" style={{ color: "red" }}>- $ {cashFlow.giftCardReturn.toFixed(2)}</td>
                                            </tr>
                                        ) : null
                                    }
                                    {
                                        cashFlow.storeCreditReturn > 0 ? (
                                            <tr>
                                                <td className="text-left">Store Credit Refund</td>
                                                <td className="text-right" style={{ color: "red" }}>- $ {cashFlow.storeCreditReturn.toFixed(2)}</td>
                                            </tr>
                                        ) : null
                                    }
                                    <tr>
                                        <td className="text-left">Expected Balance To Receive (Cash)</td>
                                        <td className="text-right"><b>$ {cashFlow.expectedBalance.toFixed(2)}</b></td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">Tips</td>
                                        <td className="text-right">
                                            $ {cashFlow.tipsTotal.toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-6">
                            <table className="table purpleText test">
                                <thead>
                                    <tr>
                                        <th>Employee #</th>
                                        <th>Name</th>
                                        <th>Login Date</th>
                                        <th>Login Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cashFlow.logIns != null && cashFlow.logIns.length > 0 ?
                                        cashFlow.logIns.map((item, index) => {

                                            return (
                                                <tr key={index}>
                                                    <td>{item.employee.id}</td>
                                                    <td>{item.employee.firstName} {item.employee.lastName}</td>
                                                    <td>{item.logInDateText}</td>
                                                    <td>{item.logInTimeText}</td>
                                                </tr>
                                            )
                                        }) : null
                                    }

                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-12">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Employee #</th>
                                        <th>Name</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>Amount</th>
                                        <th>Type</th>
                                        <th>Cash Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        cashInsCashDrops.length > 0 ?
                                            cashInsCashDrops.map((item, index) => {
                                                let cashCount = cashRegisterCount && cashRegisterCount.length > 0 ? cashRegisterCount.filter(_ => _.cashDropId === item.id || _.cashInId === item.id) : [];
                                                if (item.employee) {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.employee.id}</td>
                                                            <td>{item.employee.firstName} {item.employee.lastName}</td>
                                                            <td>{item.dateText}</td>
                                                            <td>{item.timeText}</td>
                                                            <td>$ {item.amount.toFixed(2)}</td>
                                                            <td>{item.type}</td>
                                                            <td>
                                                                {cashCount.length > 0 ?
                                                                    <CashCountDialog
                                                                        cashCount={cashCount[0]}
                                                                        time={item.timeText}
                                                                    /> : null
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            })
                                            : null

                                    }
                                    {
                                        cashFlow.status != 'Opened' && cashFlow.employee != null ?
                                            <tr className="purpleTextTable">
                                                <td>{cashFlow.employee.id}</td>
                                                <td>{cashFlow.employee.firstName} {cashFlow.employee.lastName}</td>
                                                <td>{cashFlow.cashOutDateText.slice(0, 10)}</td>
                                                <td>{cashFlow.cashOutDateText.slice(11)}</td>
                                                <td>$ {cashFlow.cashOutAmount.toFixed(2)}</td>
                                                <td>Cash Out</td>
                                                <td>
                                                    {cashRegisterCount != null && cashRegisterCount.length > 0 && cashRegisterCount.filter(_ => _.type == 3).length > 0 ?
                                                        <CashCountDialog
                                                            cashCount={cashRegisterCount.filter(_ => _.type == 3)[0]}
                                                            time={cashFlow.cashOutDateText.slice(11)}
                                                        /> : null
                                                    }
                                                </td>
                                            </tr> : null
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <hr />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <p>
                                <b>Actual Cash Out Amount</b>
                                <span className="pull-right">Verified expected and actual are equal:&nbsp;
                                    {
                                        p.amount === cashFlow.expectedBalance
                                            ? (<span className="label label-success">CORRECT</span>)
                                            : p.amount >= cashFlow.expectedBalance - p.toleranceCashOutAmount && p.amount <= cashFlow.expectedBalance + p.toleranceCashOutAmount
                                                ? (<span className="label label-info">CORRECT WITH TOLERANCE OF $ {p.toleranceCashOutAmount.toFixed(2)} </span>)
                                                : (<span className="label label-danger">DIVERGENT</span>)
                                    }
                                </span>
                            </p>
                            {
                                cashFlow && cashFlow.verifiedBy ?
                                    <p className="pull-right">Status: {cashFlow.status} -  Verified by: {cashFlow.verifiedBy.firstName} {cashFlow.verifiedBy.lastName}</p>
                                    : ""

                            }
                            <DecimalInput
                                name={p.name + "CashOutAmount"}
                                label="Actual Cash Out Amount"
                                floatingLabelText="Actual Cash Out Amount"
                                hintText="Actual Cash Out Amount" />
                        </div>
                        {
                            this.props.cashFlow && this.props.cashFlow.status !== "Opened" &&
                            <div className="col-lg-12">
                                <Button
                                    name="saveButton"
                                    label="Print Cashout Slip"
                                    className="btnNewBrandPOS"
                                    primary={true}
                                    onTouchTap={() => this.printCashout()} />
                            </div>
                        }
                    </div>
                    <div className="row">
                        <div className="col-lg-9">
                            <h4 className="d-inline-block purpleText">Orders {pinPasswordEnabled ? "" : `for ${cashFlow.employee.firstName} ${cashFlow.employee.lastName}`} under {cashFlow.deviceName}  (Total: {p.cashFlowOrders.length})</h4>
                        </div>
                        <div className="col-lg-3 text-right">
                            {
                                p.cashFlowOrders && p.cashFlowOrders.length > 0 ?
                                    <Button
                                        name="saveButton"
                                        className="printAllBtn btnNewBrandPOS"
                                        label="Print All Receipts"
                                        primary={true}
                                        onTouchTap={() => this.printAll()} />
                                    : null
                            }
                        </div>
                        <div className="col-lg-12">    
                            <p className="remark red-text">
                                Note: If an order is created under this cash flow but updated in another cash flow, it will show in both cashflows.
                            </p>
                            <div className="table_scrollable">
                                <table className="table table_center">
                                    <thead>
                                        <tr>
                                            <th>Order #</th>
                                            <th>Status</th>
                                            <th>Cash Payment</th>
                                            <th>Debit Payment</th>
                                            <th>Credit Payment</th>
                                            <th>Gift Card Payment</th>
                                            <th>Total Payment (Tips not included)</th>
                                            <th>Total Tips</th>
                                            <th>Cash Refund</th>
                                            <th>Debit Refund</th>
                                            <th>Credit Refund</th>
                                            <th>Gift Card Refund</th>
                                            <th>Store Credit Refund</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            <tr className="purpleTextTable" style={{ height: '50px', backgroundColor: "#dcceeb", fontWeight: "bold" }}>
                                                <td>All Orders</td>
                                                <td></td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.cashPaymentAmount).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.debitPaymentAmount).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.creditPaymentAmount).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.giftCardPayment).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.totalPaymentAmount).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.totaltipAmount).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.cashRefundAmount).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.debitRefundAmount).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.creditRefundAmount).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.giftCardRefund).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                                <td>$ {p.cashFlowOrders.map(_ => _.storeCreditRefund).reduce(function (a, b) { return a + b; }, 0).toFixed(2)}</td>
                                            </tr>
                                        }
                                        {
                                            this.state.sortedCashFlowOrders && this.state.sortedCashFlowOrders.map((item, index) => {
                                                return (
                                                    <tr key={index} style={{ height: '50px' }} className="purpleTextTable">
                                                        <td><Link to={`/admin/orders/detail/${item.orderId}`}>{item.orderId}</Link></td>
                                                        <td style={item.orderStatus != "Completed" ? { color: '#FF4C5B' } : {}}>{item.orderStatus}</td>
                                                        <td>$ {(item.cashPaymentAmount).toFixed(2)}</td>
                                                        <td>$ {(item.debitPaymentAmount).toFixed(2)}</td>
                                                        <td>$ {(item.creditPaymentAmount).toFixed(2)}</td>
                                                        <td>$ {(item.giftCardPayment).toFixed(2)}</td>
                                                        <td>$ {(item.totalPaymentAmount).toFixed(2)}</td>
                                                        <td>$ {(item.totaltipAmount).toFixed(2)}</td>
                                                        <td>$ {(item.cashRefundAmount).toFixed(2)}</td>
                                                        <td>$ {(item.debitRefundAmount).toFixed(2)}</td>
                                                        <td>$ {(item.creditRefundAmount).toFixed(2)}</td>
                                                        <td>$ {(item.giftCardRefund).toFixed(2)}</td>
                                                        <td>$ {(item.storeCreditRefund).toFixed(2)}</td>
                                                        <td>
                                                            {
                                                                item.status === 'Opened' ?
                                                                    (
                                                                        <Button
                                                                            type="RaisedButton"
                                                                            name="cancelButton"
                                                                            className="pull-right btnNewBrandPOS"
                                                                            label={"Cancel Order"}
                                                                            disabled={!cashFlow}
                                                                            onTouchTap={() => this.openDialogCancelOrder(item.orderId, item.notes)} />
                                                                    ) : null
                                                            }
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <h3 className="col-lg-12">Notes</h3>
                        <div className="col-lg-12">
                            <GenericTable
                                className="cashFlowNoteTable"
                                columns={LOOKUP.cashregister.notesTableColumns}
                                rows={mapCashflowNote(cashFlow.notes, cashFlow.cashFlowNotes)}
                            />
                        </div>
                    </div>
                </CardSimple>
                <div className="row mt-2">
                    <div className="col-lg-12 p-0">
                        <Button
                            name="saveButton"
                            className="pull-right btnNewBrandPOS"
                            label="Verify"
                            primary={true}
                            onTouchTap={() => this.verify()} />
                        <Button
                            name="buttonCancel"
                            primary={true}
                            className="pull-right btn-space btnNewBrandPOS"
                            label="Not Verified"
                            onTouchTap={() => this.notVerify()} />
                        <Button
                            type="CancelButton"
                            name="buttonCancel"
                            className="pull-right btn-space btnCancelOperation"
                            label={LOOKUP.product.controls.cancelButton}
                            onTouchTap={() => this.redirectToListCashFlow()} />
                    </div>
                </div>
                <DialogInput
                    title={<DialogHeader text={LOOKUP.pos.cancellationDialog.title} />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeDialogCancelOrder()} />,
                        <Button
                            key={2}
                            name="buttonRemoveItem"
                            label="Confirm"
                            primary={true}
                            className="btnNewBrandPOS"
                            onTouchTap={() => this.cancelOrder()} />]}
                    modal={true}
                    open={this.state.dialogCancelOrder}>
                    <div>
                        <div className="row modal-font-family">
                            <div className="col-lg-12" style={{ whiteSpace: 'pre-line' }}>
                                <p>Do you really want to cancel this order?</p>
                                <p>To confirm it you must add a Comment for the order.</p>
                                <label>Order Notes: </label>
                                <p>{(!s.orderNotes || s.orderNotes.length === 0) ? "No notes for this order" : s.orderNotes}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <TextInput name={`${p.name}CancellationNotes`}
                                    label="Notes"
                                    floatingLabelText="Notes"
                                    hintText="Notes"
                                    fullWidth={true}
                                />
                            </div>
                        </div>
                    </div>
                </DialogInput>
            </Grid>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        applicationSettings: state.common.applicationSettings,
        cashFlow: state.entity.cashFlow,
        cashFlowOrders: state.entity.cashFlowOrders,
        toleranceCashOutAmount: state.common.applicationSettings.toleranceCashOutAmount,
        amount: state.form[`${props.name}CashOutAmount`] ? parseFloat(state.form[`${props.name}CashOutAmount`]) : 0,
        cancellationNotes: state.form[`${props.name}CancellationNotes`],
        notes: state.form[`${props.name}Notes`],
        posOrderCancelled: state.form["posOrderCancelled"],
        saveSuccess: state.form[props.name + "SaveSuccess"],
        saveError: state.form[props.name + "SaveError"],
        branchId: state.common.branchId,
        userPin: JSON.parse(sessionStorage.getItem('pinUser')) ? JSON.parse(sessionStorage.getItem('pinUser')) : state.entity.pin,
        cashFlowOrdersDetail: state.entity.cashFlowOrdersDetail,
        printAllReceiptTime: state.entity.printAllReceiptTime,
        store: state.common.store,
        fianlSaleTextShowOnReceipt: state.common.applicationSettings.fianlSaleTextShowOnReceipt,
        fulfillmentEnabled: state.common.applicationSettings.fulfillmentEnabled,
        monerisGiftCardEnabled: state.common.applicationSettings.monerisGiftCardEnabled,
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        cashRegisterCount: state.entity.cashFlowRegisterCount || [],
        padVersion: state.common.applicationSettings.padVersion,
        isShopNameDisplayed: state.common.applicationSettings.isShopNameDisplayed,
        showOriginalNonMemberPrice: state.common.applicationSettings.showOriginalNonMemberPrice,
        showEmployeeNameOnReceipt: state.common.applicationSettings.showEmployeeNameOnReceipt,
        posReceiptBottomText: state.common.applicationSettings.posReceiptBottomText,
        receiptShowGSTNumber: state.common.applicationSettings.receiptShowGSTNumber,
        receiptShowTerminal: state.common.applicationSettings.receiptShowTerminal,
        receiptShowEmployee: state.common.applicationSettings.receiptShowEmployee,
        receiptShowOrderNumber: state.common.applicationSettings.receiptShowOrderNumber,
        receiptShowMemberSavings: state.common.applicationSettings.receiptShowMemberSavings,
        receiptShowProductCount: state.common.applicationSettings.receiptShowProductCount,
        receiptShowCreatedDate: state.common.applicationSettings.receiptShowCreatedDate,
        inStoreTipEnabled : state.common.applicationSettings.inStoreTipEnabled
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        getCashFlow: (cashFlowId, branchId) => dispatch(getCashFlow(cashFlowId, branchId)),
        getCashFlowOrders: (cashFlowId, branchId) => dispatch(getCashFlowOrders(cashFlowId, branchId)),
        cashFlowRegisterCountGet: (model) => dispatch(cashFlowRegisterCountGet(model)),
        cancelOrder: (orderId, model) => dispatch(cancelOrder(orderId, model)),
        formError: (name, error) => dispatch(formError(name, error)),
        verify: (model) => dispatch(verifyCashOut(model, ownProps.name)),
        notVerify: (model) => dispatch(notVerifyCashOut(model, ownProps.name)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearCashFlow: () => dispatch(clearCashFlow()),
        getCashFlowOrderDetail: (model) => dispatch(getCashFlowOrderDetail(model)),
        cashFlowRegisterCountGet: (id) => dispatch(cashFlowRegisterCountGet(id)),
        cashFlowRegisterCountClear: () => dispatch(cashFlowRegisterCountClear()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    }
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(CashRegisterSave));